import { SubscriptionPlanType } from 'src/services/subscriptionApi/interfaces/subscriptionApi.interface'

const PLAN_DISPLAY_NAMES: Record<SubscriptionPlanType, string> = {
  custom: 'Custom',
  daily: 'Daily Data Fetch',
  monthly: 'Monthly Data Fetch',
  none: 'Free',
  weekly: 'Weekly Data Fetch',
}

export const getPlanDisplayName = (plan: SubscriptionPlanType): string =>
  PLAN_DISPLAY_NAMES[plan] || 'Free'
